import React, { useEffect, useState } from "react";

const Loading = (props) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) return 100;
        return prev + Math.random() * 10;
      });
    }, 200);
    return () => clearInterval(progressInterval);
  }, []);

  if (props.loading >= 3) return null;

  return (
    <div className="fixed inset-0 z-50 w-screen h-screen bg-gray-900 flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center">
        <div className="mb-8">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gray-800 shadow-lg">
            <span className="text-white font-bold text-2xl tracking-widest">FL</span>
          </div>
        </div>
        <div className="w-full max-w-xs mx-auto mb-4">
          <div className="bg-gray-800 rounded-full h-2 overflow-hidden">
            <div
              className="bg-blue-500 h-full rounded-full transition-all duration-300 ease-out"
              style={{ width: `${Math.min(progress, 100)}%` }}
            />
          </div>
          <p className="text-gray-400 text-xs mt-2 text-center">
            Chargement... {Math.round(Math.min(progress, 100))}%
          </p>
        </div>
        <p className="text-gray-400 text-sm mt-6 text-center">
          Portfolio en cours d'initialisation
        </p>
      </div>
    </div>
  );
};

export default Loading;
